import Button from "../../../../components/common/ui/Button";
import { history } from "../../../../_helpers";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import RadioInput from "../../../../components/common/ui/Inputs/RadioInput";
import PasswordInput from "../../../../components/common/ui/Inputs/PasswordInput";
import { useDispatch, useSelector } from "react-redux";
import { memberActions } from "../../../../_store/members.slice";
import memberSchema from "../../../../validation/Admin/memberSchema";
import { useEffect, useState } from "react";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../../../components/common/ui/Loader";
import { useLocation } from "react-router-dom";
import { masterActions } from "../../../../_store/master.slice";
import { encryptData } from "../../../../utils/encryptDecrypt";
import { CheckBoxInput } from "../../../../components/common/ui/Inputs";
import editIcon from "../../../../assets/svg/edit-icon.svg";
import formatPhoneNumber from "../../../../_helpers/formatPhoneNumber";
import Table from "../../../../components/common/table/Table";
import ToggleSwitch from "../../../../components/common/ui/Inputs/ToggleSwitch";
import warningIcon from "../../../../assets/constant-contact-warning.png";
import EmailUnsubscribe from "../../../../assets/email-unsubscribe.png";
import Swal from "sweetalert2";
function CommitteeMemberPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [createMember, setCreateMember] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { committeeMemberForm, loading } = useSelector((x) => x?.members);

  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);
  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&active=${true}`,
  );
  const [editRow, setEditRow] = useState({});
  const {
    rolesList,
    loading: masterLoading,
    getCommitteeListResponse,
  } = useSelector((x) => x?.master);
  const { membersByCommitteeList } = useSelector((x) => x?.members);
  const committee = location?.state?.committee;
  const userList = membersByCommitteeList?.data?.users;
  const totalCount = membersByCommitteeList?.data?.totalItems || 0;
  const { statusOptions } = useSelector((x) => x?.dropDown);
  const userRoleID = JSON?.parse(sessionStorage?.getItem("userRoleID"));

  const { ActiveStatus } = useSelector((x) => x?.dropDown);

  const [Filters, SetFilters] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    status: true,
  });

  const columns = [
    {
      name: "Member ID",
      key: "memberId",
      selector: (row) => row.memberId,
      sortable: true,
      // width: "272px"
    },
    {
      name: "First Name",
      key: "firstName",
      selector: (row) => row.firstName,
      sortable: true,
      //  width: "272px"
    },
    {
      name: "Last Name",
      key: "lastName",
      selector: (row) => row.lastName,
      sortable: true,
      //  width: "272px"
    },
    {
      name: "Email",
      key: "email",
      selector: (row) => row.email,
      sortable: true,
    },

    {
      name: "Phone No",
      key: "phoneNumber",
      selector: (row) => row.phoneNumber,
      sortable: true,
    },
    {
      name: "Role",
      key: "role",
      selector: (row) => row.role,
      cell: (row) => (
        <div className="">
          {row.role === 3
            ? "Super Admin"
            : row?.role === 2
              ? "Committee Chair"
              : "Committee Member"}
        </div>
      ),
      sortable: true,
    },

    {
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          {/* <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              editEvent(row);
            }}
          /> */}

          {/* {console.log("row", row.blockedCommittees)}
          {console.log("comm", committee?._id)} */}
          {/* {console.log("committee", committee)} */}
          {row?.role !== 2 && (
            <ToggleSwitch
              name={`Status${row.memberId}`}
              id={`Status${row.memberId}`}
              // checked={row.status === true}
              checked={
                row?.blockedCommittees?.some(
                  (id) =>
                    id.toString().trim() === committee?._id?.toString().trim(),
                )
                  ? false
                  : true
              }
              // value={row.status === true ? 1 : 0}
              value={
                row?.blockedCommittees?.some(
                  (id) =>
                    id.toString().trim() === committee?._id?.toString().trim(),
                )
                  ? 1
                  : 0
              }
              handleClick={(e) => handleMemberStatus(e, row)}
            />
          )}

          {/* This need to work after going to live */}
          {/* {(userRoleID === 3 || (userRoleID ===2 && row?.role ===1) )&& (
            <ToggleSwitch
              name={`Status${row.memberId}`}
              id={`Status${row.memberId}`}
              checked={row.status === true}
              value={row.status === true ? 1 : 0}
              handleClick={(e) => handleMemberStatus(e, row)}
            />
          )} */}

          {row?.ccIsEmailSubscription === false && row?.role !== 3 && (
            <div className="d-flex gap-2">
              <img
                src={EmailUnsubscribe}
                title="Un-Subscribed Email in CC"
                alt="warning-icon"
                aria-hidden="true"
                height={"20px"}
                width={"20px"}  
              />
            </div>
          )}

          {/* {row?.ccIsVerified === false && (
            <div className="d-flex gap-2">
              <img
                src={warningIcon}
                title="Member may not be mapped to the committee in CC. Reconnect CC and update to reflect the changes"
                alt="warning-icon"
                aria-hidden="true"
                className="sbpc-icon-size"
              />
            </div>
          )} */}
          {row?.ccIsEmailSubscription === true &&
            row?.ccIsVerified === false && (
              <div className="d-flex gap-2">
                <img
                  src={warningIcon}
                  title="Member may not be mapped to the committee in CC. Reconnect CC and update to reflect the changes"
                  alt="warning-icon"
                  aria-hidden="true"
                  className="sbpc-icon-size"
                />
              </div>
            )}
        </div>
      ),
      sortable: false,
    },
  ];

  const editEvent = (row) => {
    const eventRow = {
      ...row,
      participateKids: row.organization?.trim() ? 1 : 0,
    };
    setEditRow(eventRow);
    setIsEditMode(true);
    setCreateMember(false);
    dispatch(memberActions?.updateCommitteeMemberForm(eventRow));
  };

  const handleMemberStatus = (e, row) => {
    // console.log("row", row);
    // console.log("committee", committee);
    dispatch(
      memberActions.changeUserStatus({
        id: row?._id,
        committee: committee?._id,
      }),
    )
      .then((result) => {
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          dispatch(
            memberActions?.getMembersbyCommitee(
              `${committee?._id}&active=${Filters?.status}`,
            ),
          );
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to delete members", "error");
      });
  };

  useEffect(() => {
    Swal.close();
  }, []);

  useEffect(() => {
    const resetHandler = () => {
      setIsEditMode(false);
      setCreateMember(false);
    };

    window.addEventListener("resetMemberPage", resetHandler);
    return () => {
      window.removeEventListener("resetMemberPage", resetHandler);
    };
  }, []);

  useEffect(() => {
    dispatch(masterActions?.getRolesList());
  }, []);

  useEffect(() => {
    const queryObj = Object.fromEntries(
      Object.entries(Filters)
        .filter(([_, v]) => v !== "") // remove empty values
        .map(([key, value]) =>
          key === "status" ? ["active", value] : [key, value],
        ), // rename status to active
    );

    const query = new URLSearchParams({
      page: "1",
      limit: "10",
      ...queryObj,
    }).toString();

    setApiParams(`&${query}`);
  }, [Filters]);

  useEffect(() => {
    if (!committee) return;
    // get members list for grid
    // fetch members when committee, pageNo, or rowCountPerPage changes
    dispatch(
      memberActions?.getMembersbyCommitee(`${committee?._id}&active=${true}`),
    );

    !isEditMode && dispatch(memberActions?.resetCommitteeMemberForm({}));
  }, [committee]);

  const handleChange = (e, select) => {
    const formData = { ...committeeMemberForm };
    if (select) {
      formData[select] = e?.value ? e?.value : 2;
      dispatch(memberActions.updateCommitteeMemberForm(formData));
      return;
    }
    const { name, value, type } = e?.target;

    if (name === "firstName" || name === "lastName") {
      const regex = /^[A-Za-z '-@_]*$/;
      if (!regex.test(value)) {
        return; // block invalid characters
      }
    }
    if (name === "password" || name === "confirmPassword") {
      const regex = /^[A-Za-z0-9!@#$%&*()+=?" _@-]*$/;
      if (!regex.test(value)) {
        return; // block invalid characters
      }
    }
    if (name === "phoneNumber") {
      const target = e?.target || {};
      const selectionStart = target.selectionStart || 0;
      const digitsOnly = value.replace(/\D/g, "");
      const formattedNumber = formatPhoneNumber(digitsOnly);

      requestAnimationFrame(() => {
        const inputElem = document.querySelector(`input[name="phoneNumber"]`);
        if (inputElem) {
          const newCursorPos = calculateNewCursorPosition(
            selectionStart,
            value,
            formattedNumber,
          );
          inputElem.setSelectionRange(newCursorPos, newCursorPos);
        }
      });

      formData[name] = formattedNumber;
      dispatch(memberActions.updateCommitteeMemberForm(formData));
      return;
    }
    formData[name] =
      type === "radio" ? (value === "true" ? true : false) : value;
    dispatch(memberActions.updateCommitteeMemberForm(formData));
  };

  const calculateNewCursorPosition = (oldPos, oldValue, newValue) => {
    let rawIndex = 0;
    let newIndex = 0;

    while (rawIndex < oldPos && newIndex < newValue.length) {
      if (/\d/.test(oldValue[rawIndex])) {
        while (newIndex < newValue.length && !/\d/.test(newValue[newIndex])) {
          newIndex++;
        }
        newIndex++;
      }
      rawIndex++;
    }
    return newIndex;
  };

  const handleFormSubmit = async (e) => {
    setIsPending(true);
    e?.preventDefault();
    setErrorMessage({});

    // ✅ Ensure defaults are set before validation
    const formWithDefaults = {
      ...committeeMemberForm,
      committees: [committee?._id], // Default committee ID
      role: isEditMode ? committeeMemberForm?.role : 1, // Default role = 1
    };

    const { error } = memberSchema(formWithDefaults, isEditMode ? true : false);
    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }
    const encryptPassword = encryptData(formWithDefaults?.password);
    const encryptConfirmPassword = encryptData(
      formWithDefaults?.confirmPassword,
    );

    const formData = { ...formWithDefaults };
    formData["password"] = encryptPassword;
    formData["confirmPassword"] = encryptConfirmPassword;
    if (formWithDefaults.memberId) {
      delete formData["password"];
      delete formData["confirmPassword"];
    }
    //API call after validation

    const request = !isEditMode
      ? dispatch(memberActions?.createCommitteeMember(formData))
      : dispatch(memberActions?.updateCommitteeMember(formData));

    request
      .then((result) => {
        if (result?.payload?.status === 1) {
          setIsPending(false);
          setCreateMember(false);
          showToastNotification(result?.payload?.message, "success");
          // dispatch(memberActions?.getMembersbyCommitee(committee?._id));
          dispatch(
            memberActions?.getMembersbyCommitee(
              `${committee?._id}&active=${Filters?.status}`,
            ),
          );
          dispatch(memberActions.resetCommitteeMemberForm());
        } else {
          showToastNotification(result?.error?.message, "error");
          setIsPending(false);
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create member", "error");
      });
    if (isEditMode) {
      setIsEditMode(false); // Exit edit mode after successful update
    }
  };
  const togglePasswordVisibility = (type) => {
    type === "password"
      ? setShowPassword((prev) => !prev)
      : setShowConfirmPassword((prev) => !prev);
  };

  const handleFormReset = () => {
    setErrorMessage({});
    isEditMode
      ? dispatch(memberActions?.updateCommitteeMemberForm(editRow))
      : dispatch(memberActions?.resetCommitteeMemberForm({}));
  };

  const handleParticipateForKidsOption = (e) => {
    const errors = { ...errorMessage };
    delete errors?.organization;
    setErrorMessage(errors);
    const { name, value } = e?.target;
    const formData = { ...committeeMemberForm };
    if (value === "0") {
      formData["organization"] = "";
    }
    formData[name] = parseInt(value);
    dispatch(memberActions.updateCommitteeMemberForm(formData));
  };

  const handlePrivateMember = (e) => {
    const { name, checked } = e?.target;
    const formData = { ...committeeMemberForm };
    formData[name] = checked ? 1 : 0;
    dispatch(memberActions.updateCommitteeMemberForm(formData));
  };

  const handleRowPerPage = (limitcount) => {
    const updatedParams = apiParams.replace(
      /&limit=\d+/,
      `&limit=${limitcount}`,
    );
    const updateIdIntoParams = `${committee?._id + updatedParams}`;
    setApiParams(updatedParams);

    dispatch(memberActions?.getMembersbyCommitee(updateIdIntoParams));
    setRowCountPerPage(limitcount);
    setPageNo(1);
  };

  const handlePageChange = (page) => {
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    const updateIdIntoParams = `${committee?._id + updatedParams}`;
    setApiParams(updatedParams);
    dispatch(memberActions?.getMembersbyCommitee(updateIdIntoParams));
    setPageNo(page);
  };

  const handleSearchChange = (e, name) => {
    // const value = e?.target?.value ?? "";
    const { value, type } = e?.target;
    if (name === "phoneNumber") {
      const target = e?.target || {};
      const selectionStart = target.selectionStart || 0;
      const digitsOnly = value.replace(/\D/g, "");
      const formattedNumber = formatPhoneNumber(digitsOnly);

      requestAnimationFrame(() => {
        const inputElem = document.querySelector(`input[name="phoneNumber"]`);
        if (inputElem) {
          const newCursorPos = calculateNewCursorPosition(
            selectionStart,
            value,
            formattedNumber,
          );
          inputElem.setSelectionRange(newCursorPos, newCursorPos);
        }
      });

      SetFilters((prevFilters) => ({
        ...prevFilters,
        [name]: digitsOnly,
      }));
      return;
    }

    SetFilters((prevFilters) => ({
      ...prevFilters,
      // [name]: value,
      [name]: type === "radio" ? (value === "true" ? true : false) : value,
    }));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPageNo(1);
    const updateIdIntoParams = `${committee?._id + apiParams}`;
    dispatch(memberActions?.getMembersbyCommitee(updateIdIntoParams));
  };

  const handleSearchFormReset = (e) => {
    e.preventDefault();
    SetFilters({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      status: true,
    });
    setPageNo(1);
    dispatch(
      memberActions?.getMembersbyCommitee(`${committee?._id}&active=${true}`),
    );
  };

  if (loading || masterLoading) return <CustomLoader />;
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">{committee?.committeeName}</h1>
        <div className="d-flex justify-content-end">
          {/* {isEditMode ? (
          <Button
            className="me-2"
            label="Create"
            status="secondary"
            onClick={() => {
              setIsEditMode(false);
              dispatch(memberActions?.resetCommitteeMemberForm({}));
            }}
          />
        ) : null} */}

          {createMember === false && (
            <Button
              className="me-2"
              label="Create"
              status="secondary"
              onClick={() => {
                setCreateMember(true);
                setIsEditMode(false);
                // dispatch(postFormAction?.resetForm({}));
                dispatch(memberActions?.resetCommitteeMemberForm({}));
              }}
            />
          )}

          <Button
            label="Back"
            status="reset"
            onClick={() => {
              setErrorMessage({});
              isEditMode === false && createMember === false
                ? history?.navigate("/Admin/CommitteePage")
                : setIsEditMode(false);
              setCreateMember(false);
            }}
          />
        </div>
      </div>

      {isEditMode === false && createMember === false && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
            Search Member
          </h1>

          <form
            className="p-3 row"
            onSubmit={(e) => {
              handleSearchSubmit(e);
            }}
            onReset={(e) => {
              handleSearchFormReset(e);
            }}
          >
            <div className="col-md-4">
              <TextInput
                label="First Name"
                placeholder="First Name"
                name="firstName"
                id="firstName"
                maxLength={25}
                handleChange={(e) => handleSearchChange(e, "firstName")}
                value={Filters?.firstName}
              />
            </div>

            <div className="col-md-4">
              <TextInput
                label="Last Name"
                placeholder="Last Name"
                name="lastName"
                id="lastName"
                maxLength={25}
                handleChange={(e) => handleSearchChange(e, "lastName")}
                value={Filters?.lastName}
              />
            </div>
            <div className="col-md-4">
              <TextInput
                label="Email"
                placeholder="Email"
                name="email"
                id="email"
                maxLength={100}
                handleChange={(e) => handleSearchChange(e, "email")}
                value={Filters?.email}
              />
            </div>

            <div className="col-md-4">
              <TextInput
                label="Phone Number"
                placeholder="Phone Number"
                name="phoneNumber"
                id="phoneNumber"
                handleChange={(e) => handleSearchChange(e, "phoneNumber")}
                value={formatPhoneNumber(Filters?.phoneNumber)}
              />
            </div>
            <div className="col-md-4">
              <RadioInput
                name="status"
                id="status"
                label="Status"
                options={ActiveStatus}
                handleChange={(e) => {
                  handleSearchChange(e, "status");
                }}
                selectedValue={Filters?.status}
              />
            </div>

            <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
              <Button status="secondary" label="Search" type="submit" />
              <Button status="reset" label="Reset" type="reset" />
            </div>
          </form>
        </div>
      )}

      {(isEditMode || createMember) && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            {!isEditMode ? "Create" : "Edit"} Committee Member
          </h1>
          <form
            onSubmit={(e) => {
              handleFormSubmit(e);
            }}
            onReset={(e) => {
              handleFormReset(e);
            }}
            className="p-3 row"
          >
            <div className="row mb-4">
              <div className="col-md-4">
                <TextInput
                  label="First Name"
                  placeholder="First name"
                  name="firstName"
                  id="firstName"
                  handleChange={(e) => handleChange(e)}
                  required
                  errorMessage={errorMessage}
                  value={committeeMemberForm?.firstName}
                  disabled={isEditMode}
                />
              </div>
              <div className="col-md-4">
                <TextInput
                  label="Last Name"
                  placeholder="Last name"
                  name="lastName"
                  id="lastName"
                  handleChange={(e) => handleChange(e)}
                  required
                  errorMessage={errorMessage}
                  value={committeeMemberForm?.lastName}
                  disabled={isEditMode}
                />
              </div>
              <div className="col-md-4">
                <TextInput
                  type="text"
                  label="Email"
                  placeholder="Email"
                  name="email"
                  id="email"
                  handleChange={(e) => handleChange(e)}
                  required
                  errorMessage={errorMessage}
                  value={committeeMemberForm?.email}
                  disabled={isEditMode}
                />
              </div>
              <div className="col-md-4">
                <TextInput
                  label="Phone Number"
                  placeholder="Phone number"
                  name="phoneNumber"
                  id="phoneNumber"
                  handleChange={(e) => handleChange(e)}
                  // required
                  errorMessage={errorMessage}
                  value={committeeMemberForm?.phoneNumber}
                  disabled={isEditMode}
                />
              </div>
              {!isEditMode && (
                <>
                  <div className="col-md-4">
                    <PasswordInput
                      name="password"
                      id="Password"
                      label="Password"
                      handleChange={(e) => handleChange(e)}
                      placeholder="Password"
                      required={true}
                      maxlength={25}
                      errorMessage={errorMessage}
                      value={committeeMemberForm?.password}
                      showPassword={showPassword}
                      togglePasswordVisibility={() =>
                        togglePasswordVisibility("password")
                      }
                      disabled={isEditMode}
                    />
                  </div>
                  <div className="col-md-4">
                    <PasswordInput
                      name="confirmPassword"
                      id="confirmPassword"
                      label="Confirm Password"
                      handleChange={(e) => handleChange(e)}
                      placeholder="Password"
                      required={true}
                      maxlength={25}
                      errorMessage={errorMessage}
                      value={committeeMemberForm?.confirmPassword}
                      showPassword={showConfirmPassword}
                      togglePasswordVisibility={() =>
                        togglePasswordVisibility("confirm")
                      }
                      disabled={isEditMode}
                    />
                  </div>
                </>
              )}
              <div className="col-md-4">
                <RadioInput
                  name="participateKids"
                  id="participateKids"
                  label="Are you participating in the Broward Partnerships for Kids as part of your professional reasons?"
                  options={statusOptions}
                  selectedValue={committeeMemberForm?.participateKids}
                  handleChange={(e) => handleParticipateForKidsOption(e)}
                  disabled={isEditMode}
                />
              </div>
              {committeeMemberForm?.participateKids === 1 && !isEditMode && (
                <div className="fs-5 text-gray">
                  “If yes, then please add your organization"
                </div>
              )}
              <div className="col-md-12">
                <TextInput
                  name="organization"
                  id="organization"
                  label="Organization"
                  placeholder="Organization"
                  handleChange={(e) => handleChange(e)}
                  value={committeeMemberForm?.organization}
                  maxLength={256}
                  // disabled={
                  //   committeeMemberForm?.participateKids === 0 || isEditMode
                  // }
                  errorMessage={errorMessage}
                  required={committeeMemberForm?.participateKids === 1}
                />
              </div>

              <div className="col-md-4 mt-4">
                <CheckBoxInput
                  label="Private Member"
                  name="privateMember"
                  id="privateMember"
                  handleClick={(e) => handlePrivateMember(e, "privateMember")}
                  checked={committeeMemberForm?.privateMember}
                  disabled={isEditMode}
                />
              </div>

              {committeeMemberForm?.role === 1 && (
                <div className="col-md-4 mt-4">
                  <RadioInput
                    name="status"
                    id="status"
                    label="Status"
                    options={ActiveStatus}
                    handleChange={(e) => handleChange(e)}
                    selectedValue={committeeMemberForm?.status}
                  />
                </div>
              )}
            </div>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <Button
                label={`${isEditMode ? "Update" : "Submit"}`}
                type="submit"
                status="secondary"
                disabled={isPending}
              />
              {!isEditMode && (
                <Button label="Reset" type="reset" status="reset" />
              )}
            </div>
          </form>
        </div>
      )}
      {isEditMode === false && createMember === false && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color p-3 ">Member List</h1>
          <Table
            columns={columns}
            data={userList}
            pagination
            onChangeRowsPerPage={handleRowPerPage}
            onChangePage={handlePageChange}
            totalRowCount={totalCount || 0}
            currentPage={pageNo}
            paginationPerPage={rowCountPerPage}
          />
        </div>
      )}
    </>
  );
}

export default CommitteeMemberPage;
